import { getApiUrl } from '../../utils/getApiUrl';
import type { WordModel } from '../../type/word';
import { fetchWithAuth } from '../../auth/auth';

export const loadWords = async (
  iddictionary: string | null,
  iduser: string | null,
  setAllWords: (words: WordModel[]) => void,
  setFilteredWords: (words: WordModel[]) => void,  
  showSpinner: () => void,
  hideSpinner: () => void,
  sortWords: (words: WordModel[], column: keyof WordModel, order: "asc" | "desc") => WordModel[],
  currentSort: { column: keyof WordModel; order: "asc" | "desc" },
  tableContainerRef: React.RefObject<HTMLDivElement | null>,
  languageDictionaryIds?: number[]
) => {
  try {
    showSpinner();
    let setUrl = `words?iddictionary=${iddictionary}`;

    if (iddictionary == null || iddictionary === "undefined") {
      setUrl = `words/getall?iduser=${iduser}`;

      //console.error("No dictionary ID provided in URL");
      //hideSpinner();
      //;
    }
    const response = await fetchWithAuth(getApiUrl(setUrl));
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    let data: WordModel[] = await response.json();

    // "All Expressions" spans every dictionary for the user; scope it to the currently selected language.
    if ((iddictionary == null || iddictionary === "undefined") && languageDictionaryIds) {
      const allowed = new Set(languageDictionaryIds);
      data = data.filter(w => w.iddictionary !== undefined && allowed.has(w.iddictionary));
    }

    setAllWords(data);


    const sorted = sortWords([...data], currentSort.column, currentSort.order);
    setFilteredWords(sorted);
    if (tableContainerRef.current) tableContainerRef.current.scrollTop = 0;
  } catch (err) {
    console.error(err);
  } finally {
    hideSpinner();
  }
};